import React from 'react';
import { motion } from 'framer-motion';
import { Users, Package, Clock, Star } from 'lucide-react';

const TrustMetrics = () => {
  const metrics = [
    {
      icon: Users,
      number: '50,000+',
      label: 'Happy Customers',
      color: 'text-brandred'
    },
    {
      icon: Package,
      number: '10,000+',
      label: 'Products in Stock',
      color: 'text-brandred'
    },
    {
      icon: Clock,
      number: '24/7',
      label: 'Support',
      color: 'text-brandred'
    },
    {
      icon: Star,
      number: '4.9/5',
      label: 'Average Rating',
      color: 'text-brandred'
    }
  ];

  return (
    <section className="py-20 bg-[#0F0F0F] text-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-headerwhite mb-4 drop-shadow">
            Trusted by <span className="text-brandred">Tacoma Owners</span>
          </h2>
          <p className="text-lg text-offwhite/80 max-w-2xl mx-auto">
            Join thousands of satisfied Toyota drivers who trust Taco Garage to upgrade their trucks right.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="bg-white/95 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm">
                <div className="w-16 h-16 bg-brandred/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <metric.icon className={`${metric.color}`} size={32} />
                </div>
                <div className={`text-3xl md:text-4xl font-bold ${metric.color} mb-2`}>
                  {metric.number}
                </div>
                <div className="text-gray-700 text-sm md:text-base font-medium">
                  {metric.label}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustMetrics; 